import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import jump from "jump.js";

$(document).ready(function() {
  if (!Abacus.PreventDefault.ScrollTo) {
    // add class to links that begin with hash
    if (document.body.id == "story" || "spin2") {
      $(".storytext a, .htmlContent a").filter(function(i, ele) {
        if (this.hash && !this.classList.contains("jumpto"))
          this.classList.add("scrollTo");
      });
    }

    $("body").on("click", ".scrollTo, .jumpto:not(.external)", function(evt) {
      if (!this.getAttribute("target") && document.querySelector(this.hash)) {
        evt.preventDefault();
        var smoothScroll = new ScrollTo();
        smoothScroll.smoothScroll(this); 
      }
    });
  }
});

let ScrollToOptions = {
  duration: 500,
  offset: 0,
  offsetCSSClass: 'scrollto-add-offset',
  offsetChildElementsToInclude: '.widget'
};

class ScrollTo extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(ScrollToOptions, options);
    this.getHeightOfMainNav();
  }

  getHeightOfMainNav() {
    function thisHeight(){
      return $(this).height();
    }
    let mainnav =
        (document.querySelector("#mainnav") &&
          document.querySelector("#mainnav").clientHeight) ||
        0,
      mastheadmast =
        (document.querySelector(".masthead .mast") &&
          document.querySelector(".masthead .mast").clientHeight) ||
        0, self = this, offset = 0;

    $('.'+this.options.offsetCSSClass).each(function(index, elem){
      let thisElemMax = Math.max.apply(Math, $(elem).find(self.options.offsetChildElementsToInclude).map(thisHeight));
      offset += Math.max($(elem).outerHeight()+(thisElemMax),thisElemMax);
      
    });
 
    this.options.offset = (mainnav > 0 ? mainnav : mastheadmast) + offset;
   
  }

  smoothScroll(element) {
    var target = element.hash;
   jump(target, {
      duration: this.options.duration,
      offset: (this.options.offset + 10) * -1
    });
  }
}

export { ScrollTo };



// WEBPACK FOOTER //
// ./Javascript/core/classes/scrollto.class.js